import NotesSkeletons from './NotesSkeletons';
export default NotesSkeletons;
